import { useEffect, useState } from "react";
import { getHabilitationList } from "api/habilitation";
import { Habilitation } from "pages/GestionHabilitation/habilitationSchema";
import { Perimetre } from "api/auth";

export function useGetHabilitation(
  codeGestionnaire?: string,
  perimetres?: Perimetre[],
  codeAssureur?: string,
  actif: boolean = true,
) {
  const [habilitations, setHabilitation] = useState<Habilitation[]>();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getHabilitationList({
      codeGestionnaire,
      codeAssureur,
      ...(actif ? { debutHabilitation: new Date() } : {}),
      size: 300,
    })
      .then((h) => {
        setHabilitation(h.habilitations);
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [actif, codeAssureur, codeGestionnaire]);

  const filteredHabilitations = habilitations?.filter(
    (h) => !perimetres || perimetres.length === 0 || perimetres.includes(h.perimetre),
  );

  const perimetresAllowed = filteredHabilitations !== undefined && filteredHabilitations.length > 0;

  return { habilitations: filteredHabilitations, error, loading, perimetresAllowed };
}
